import styled from 'styled-components';
import ClampLines from 'react-clamp-lines';
import {
  Button as SemanticButton,
  Dropdown as SemanticDropdown,
  Image,
  Dimmer as SemanticDimmer,
  Loader as SemanticLoader,
  Icon,
  Popup,
} from 'semantic-ui-react';

import { Segment as SegmentLayoutComponent } from '@playbookux/playbook-web-core';

const Typography = styled.p`
  font-size: ${(props) => (props.fontSize ? props.fontSize : '24px')};
  color: #192c47;
  font-weight: ${(props) => (props.weight ? props.weight : 'normal')};
  &&&&& {
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : '0')};
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '')};
  }
`;

const ProjectTypeContainer = styled.span`
  display: flex;
  align-items: center;
  line-height: 100%;
  padding-left: 5px;
`;

const ProjectName = styled(ClampLines)`
  font-size: 17px;
  color: #192c47;
  line-height: 1.2em;
  font-weight: 500;
  word-wrap: break-word;
  word-break: break-word;
  &&&&& {
    margin-top: 20px;
    margin-bottom: 1px;
  }
  float: left;
`;

const ProjectDescription = styled(ClampLines)`
  font-size: 16px;
  color: #192c47;
  margin-top: 5px;
  line-height: 1.2em;
  word-wrap: break-word;
`;

const Project = styled(SegmentLayoutComponent)`
  &.ui.segment {
    cursor: pointer;
    height: 280px;
    margin: 10px;
    max-width: 280px;
    min-width: 280px;
    padding: 20px;
    width: 20%;
  }
`;

const ProjectContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

const ProjectMenu = styled(SegmentLayoutComponent)`
  &.ui.segment {
    align-self: flex-end;
    position: absolute;
  }
`;

// FIXME: put in values file
const ProjectMenuItem = styled.div.attrs((props) => {
  const color = props.color || '#ED3A4E';
  return {
    color,
  };
})`
  display: inline-block;
  font-size: 12px;
  color: ${(r) => r.color};
  border: 0;
  padding: 0px;
`;

const Button = styled(SemanticButton).attrs((props) => {
  const color = props.color || '#ED3A4E';
  const backgroundColor = props.backgroundColor || '#FFFFFF';
  return {
    color,
    backgroundColor,
  };
})`
  &&& {
    text-align: center;
    color: ${(r) => r.color};
    background-color: ${(r) => r.backgroundColor};
    box-shadow: 1px 1px 1px grey;
    font: "Roboto Medium";
    font-size: 14pt;
    margin: 5pt;
  }
`;

const CustomIcon = styled.div`
  padding: 10px;
  display: flex;
`;

const ImageIcon = styled(Image)`
  &.ui.image {
    height: 4px;
    margin: auto;
    width: 18px;
  }
`;

const Dropdown = styled(SemanticDropdown)`
&&& {
  position: absolute;
  right: 0px;
  top: 0;

  &&:hover {
    background: ${(props) => props.theme.color.whtite};
  }
  &.active {
    background: ${(props) => props.theme.color.whtite};
  }
  &.ui.dropdown>.dropdown.icon{
    display: none;
  }
}
`;

const Dimmer = styled(SemanticDimmer)``;

const Loader = styled(SemanticLoader)`
  padding-right: 5px;
`;

const ProjectHeader = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
`;

const DeviceIconContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
`;

const DeviceIcon = styled.img`
  height: 40px;
  width: auto;
  margin-right: 10px;
`;

const ContainerIcon = styled.div`
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e3eefc;
  width: 15px;
  height: 15px;
  margin-left: 5px;
`;

const QuestionMarkIcon = styled(Icon)`
  && {
    font-size: 0.6em;
    margin: 0;
    height: unset;
  }
`;

const Tooltip = styled(Popup)``;

const ContainerStatus = styled.span`
  display: flex;
`;

export {
  Button,
  DeviceIcon,
  DeviceIconContainer,
  Dropdown,
  ImageIcon,
  Project,
  ProjectContent,
  CustomIcon,
  ProjectDescription,
  ProjectHeader,
  ProjectMenu,
  ProjectMenuItem,
  ProjectName,
  Typography,
  Dimmer,
  Loader,
  ProjectTypeContainer,
  ContainerIcon,
  QuestionMarkIcon,
  Tooltip,
  ContainerStatus,
};
